import { render } from "./doctorsView.vue?vue&type=template&id=43c70f38&scoped=true"
import script from "./doctorsView.vue?vue&type=script&lang=js"
export * from "./doctorsView.vue?vue&type=script&lang=js"

import "./doctorsView.vue?vue&type=style&index=0&id=43c70f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c70f38"]])

export default __exports__